<!-- template v.1 -->
<template>
<div class="col py-3">
            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Carga de Marcaciones </h4>
              <span style="font-size: 20px;">{{Nombres}}</span>
            </div>
             <div class="col-md-12" style="padding:0">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Carga de Archivo</h3>
                
              </div>
              <div class="card-body" style="padding-top:18px">
                    <div class="col-md-12">
                  
                        <div  >

                            <input
                                type="file"
                                placeholder="Subir Archivo"
                                label="Subir Archivo"
                                @change="onFileSelected"

                            />

                            

                        
                        </div>
                    </div>
                
              </div>

              <!-- /.card-body -->
            </div>
           
          

      </div>

</div>

<div class="overlay-wrapper"  v-if="load">
        <div class="overlay" style="flex-direction: column;">
            <i class="spinner-border"></i>
            <div class="text-bold pt-2">Cargando...</div>
        </div>
    </div>
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
        load: false,

      Empleado:this.$route.query.id,
      Nombres:this.$route.query.nombre,



      
    };
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=7", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Marcaciones = response.data.oListaParametros;
        })
    
    
    
  },
  methods: {
        onFileSelected (event) {
               const file = event.target.files[0];
               //console.log(file);
               const bodyFormData = new FormData();
               bodyFormData.append("File", file);

               let gestion = this.$store.state.menu;

               this.axios.post(gestion + "/importarMarcacion", bodyFormData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        "Content-Type": "multipart/form-data",
                    }
                    })
                    .then((response) => {
                        console.log(response);
                        
                        
                        const data_res = response.data.satisfactorio;

                        if (data_res == true) { 

                            this.$swal({
                            toast: true,
                            timer:3000,
                            position: 'top',
                            showConfirmButton: false,
                            title: 'Se cargó exitosamente',
                            icon: 'success',
                            
                            });
                        }
                        else {
                            this.$swal({
                            toast: true,
                            timer:3000,
                            position: 'top',
                            showConfirmButton: false,
                            title: 'Error al cargar',
                            icon: 'error',
                            
                            });  
                        }
                        
                        
                    });

            }

  },
}
</script>
<style scoped>
.btn-table{
    margin: 0 5px;

}

</style>
